import {action, makeObservable, observable, runInAction} from 'mobx'
import {ProductListItemViewModel} from '@/src/entities/product/model'
import {Product} from '@/src/core/domain/entities/product'
import type {BasketStoreInterface} from '@/src/presentation/stores/basket/basket.store.interface'
import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import type {ProductListItemViewModelFactory} from '@/src/features/catalog/product-list/product-item-factory'

@injectable()
export class CatalogProductListVM {
  @observable
  products: ProductListItemViewModel[] = []

  productVM_Factory!: ProductListItemViewModelFactory

  constructor(
    @inject(DI.ProductListItemViewModelFactory) productVM_Factory: ProductListItemViewModelFactory,
    products: Product[],
    basket?: BasketStoreInterface,
  ) {
    this.productVM_Factory = productVM_Factory

    makeObservable(this)

    runInAction(() => {
      this.products = products.map(product => this.productVM_Factory(product, basket))
    })
  }

  @action.bound
  setProducts(products: Product[], basket?: BasketStoreInterface) {
    this.products = products.map(product => this.productVM_Factory(product, basket))
  }

  getByKey(key: React.Key) {
    return this.products.find(vm => vm.key == key)
  }
}

export type CatalogProductListViewModelFactory = (
  products: Product[],
  basket?: BasketStoreInterface,
) => CatalogProductListVM
